<script setup lang="ts">
interface Props {
  // Only the shape stays a prop — size/layout is owned by the parent grid so skeletons
  // always take the form of the cell they sit in.
  radius?: string
}

withDefaults(defineProps<Props>(), {
  radius: '6px',
})
</script>

<template>
  <div class="skeleton-rectangle" :style="{borderRadius: radius}"/>
</template>

<style scoped lang="scss">
@use '../../../styles/variables' as variables;

.skeleton-rectangle {
  width: 100%;
  height: 100%;
  background: map-get(variables.$colors, container-high);
  animation: skeleton-rectangle-pulse 1.2s ease-in-out infinite;
}

@keyframes skeleton-rectangle-pulse {
  0%, 100% {
    opacity: 0.35;
  }

  50% {
    opacity: 0.7;
  }
}
</style>
